module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/showcase-30.vue");


//////////////////
// WEBPACK FOOTER
// ./en/about/showcase.md
// module id = 476
// module chunks = 403